const ITEMS = [
  "Kashmir", "Goa", "Kerala", "Udaipur",
  "Every Journey. Personally Managed.",
  "Your Budget. Your Journey.",
];

export const Marquee = ({ light = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-6 ${light ? "border-black/10 bg-bone" : "border-white/10 bg-obsidian"}`}
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={`whitespace-nowrap font-serif text-2xl font-light italic tracking-wide sm:text-3xl ${
                    light ? "text-zinc-700" : "text-zinc-500"
                  }`}
                >
                  {item}
                </span>
                <span className={`mx-8 text-xs ${light ? "text-gold-muted" : "text-gold"}`}>&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
